// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

var chroma = require("chroma-js");
var tinycolor = require("tinycolor2");

const fonts = {
  display: "bio-sans, sans-serif",
  default: "bio-sans, sans-serif",
  serif: "study, serif",
  paragraph: "bio-sans, sans-serif",
  mono: "'Andale Mono', 'Consolas', sans-serif"
};

//let spinAmount = 15
let colorWhite = "#ffffff";
let colorBlack = "#0C001C";
let colorGray = "#7F7D82";
let colorPrimary = "#ff0051";
let colorSecondary = "#3f0068";
let colorTertiary = "#ff2731";
let colorComp = "#ff6200";
let colorBg = "#000000";
let colorText = tinycolor
  .mostReadable(colorBg, [colorWhite, colorBlack])
  .toString();

// Make those gradients
let colorscale = chroma
  .scale([colorBg, colorTertiary, colorPrimary, colorSecondary, colorComp])
  .mode("lab");
let grayscale = chroma.scale([colorBlack, colorGray, colorWhite]).mode("lab");

const colors = {
  white: colorWhite,
  black: colorBlack,
  primary: colorPrimary,
  secondary: colorSecondary,
  tertiary: colorTertiary,
  complimentary: colorComp,
  text: colorText
};

let fontSize = 16;
let lineHeight = 1.5;
let cap = -4.5;
let baseUnit = "px";
let space = fontSize * lineHeight;
let timer = 266;

const sizes = {
  fontSize: fontSize,
  lineHeight: lineHeight,
  cap: cap,
  borderWidth: 1,
  timer: timer,
  space: space
};
const zindex = {
  cover: 400,
  hud: 300,
  ui: 200,
  background: 0
};
const breakpoints = [576, 768, 992, 1200, 1920];

export { fonts, colors, sizes, zindex, colorscale, breakpoints, grayscale };

export function expandValue(value, unit = baseUnit) {
  return `${value}${unit}`;
}

export function typeSet(fontsizeT = fontSize, lineHeightT = lineHeight) {
  let spacer = fontSize * lineHeight * 0.5;
  let intHeight = fontsizeT * lineHeightT;
  let finLineHeight = Math.ceil(intHeight / spacer) * spacer;
  return {
    lineHeight: expandValue(finLineHeight),
    fontSize: expandValue(fontsizeT)
  };
}

export function uppercase() {
  return {
    textTransform: "uppercase",
    letterSpacing: "0.1rem"
  };
}

export function background(color = colorPrimary, colorHover = colorTertiary) {
  return {
    // Fallback
    backgroundColor: color,
    // Make it fancy
    backgroundImage:
      "linear-gradient(to bottom, " + color + " 0%, " + colorHover + " 100%)"
  };
}

export function borderRadius(radius = space * 0.25) {
  return {
    borderRadius: radius,
    backgroundClip: "padding-box"
  };
}

export function transition(
  typeT = "all",
  timerT = timer + "ms",
  timingT = "cubic-bezier(0.2, 0.53, 0.55, 0.86)"
) {
  return {
    transition: typeT + " " + timerT
  };
}

export function padding(type = "all", padding = expandValue(space)) {
  if (type === "all") {
    return {
      padding: padding
    };
  } else if (type === "top") {
    return {
      paddingTop: padding
    };
  } else if (type === "right") {
    return {
      paddingRight: padding
    };
  } else if (type === "bottom") {
    return {
      paddingBottom: padding
    };
  } else if (type === "left") {
    return {
      paddingLeft: padding
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/theme.js